import React from "react";
import { Container } from "reactstrap";
import { Carousel } from "react-responsive-carousel";
import styled from "styled-components";
import DoubleSplitVanity from "./images/Mirrors/DoubleSplitVanity_Web.jpg";
import DoubleVanityFull from "./images/Mirrors/DoubleVanityFull_Web.jpg";
import OvalMirrors from "./images/Mirrors/OvalMirrors_Web.jpg";
import ExerciseMirrors from "./images/Mirrors/ExerciseMirror_Web.jpg";

const SliderImg = styled.img`
  width: 100%;
  overflow: hidden;
`;

const Mirrors = props => {
  return (
    <Container>
      <h2>Custom Mirrors</h2>
      <hr />

           <p>
      Mirrors can enhance any space in your home or business. We stock high quality 1/4” mirror, which can be cut to your exact size and specifications. We can even account for outlet holes, light holes and can even cut our mirrors to fit corners. In addition we also stock several sizes of frameless penciled edge mirrors.      </p>
      <p>
      We also specialize in creating framed or frameless mirrors, with or without beveled edges; Antiqued, Exercise Room, and Floor to Ceiling Mirrors.      </p>
      <Carousel infiniteLoop showThumbs={false} showIndicators={false}>
        <div>
          <SliderImg src={DoubleSplitVanity} />
        </div>
        <div>
          <SliderImg src={DoubleVanityFull} />
        </div>
        <div>
          <SliderImg src={OvalMirrors} />
        </div>
        <div>
          <SliderImg src={ExerciseMirrors} />
        </div>
      </Carousel>
 
      
    </Container>
  );
};

export default Mirrors;



// WEBPACK FOOTER //
// ./src/Mirrors.js